module.exports = __webpack_public_path__ + "static/media/sites_white-01.71cb9ca3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/sites_white-01.png
// module id = 7695
// module chunks = 0